import { useEffect } from 'react'
import { COMPANY, IMAGES } from '../data/siteData'

function setOrCreateMeta(attrName, attrValue, content) {
  if (!content) return
  let el = document.querySelector(`meta[${attrName}="${attrValue}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attrName, attrValue)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

export default function SeoHead({
  title,
  description,
  schemaData,
  canonicalPath = '',
  image
}) {
  useEffect(() => {
    if (title) {
      document.title = title
      setOrCreateMeta('property', 'og:title', title)
      setOrCreateMeta('name', 'twitter:title', title)
    }

    if (description) {
      setOrCreateMeta('name', 'description', description)
      setOrCreateMeta('property', 'og:description', description)
      setOrCreateMeta('name', 'twitter:description', description)
    }

    const ogImage = image || IMAGES?.hero || 'https://assets.auxodev.dk/assets/385186cd-968f-4839-8612-1c0b142a077c/jt-knudsen-minigraver-haveanlaeg-terrasse.jpeg'
    setOrCreateMeta('property', 'og:image', ogImage)
    setOrCreateMeta('name', 'twitter:image', ogImage)
    setOrCreateMeta('name', 'twitter:card', 'summary_large_image')

    // Canonical link
    let canonical = document.querySelector('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.setAttribute('rel', 'canonical')
      document.head.appendChild(canonical)
    }
    canonical.setAttribute('href', window.location.origin + (canonicalPath || window.location.pathname))

    // JSON-LD scripts management
    const scriptId = 'page-jsonld-schema'
    let existingScript = document.getElementById(scriptId)
    if (existingScript) {
      existingScript.remove()
    }

    if (schemaData) {
      const script = document.createElement('script')
      script.id = scriptId
      script.type = 'application/ld+json'
      script.text = JSON.stringify(schemaData)
      document.head.appendChild(script)
    }

    return () => {
      const s = document.getElementById(scriptId)
      if (s) s.remove()
    }
  }, [title, description, schemaData, canonicalPath, image])

  return null
}
